import './style/reset.css';
import './style/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Navbar from './components/Navbar';
import MainFlow from './pages/MainFlow';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import Discover from './pages/Discover';


function App() {
  return (
    <div className="App">
            <Router>
              <Navbar/> 
                <div className="wrapper">
                  <Switch>
                    <Route path="/" exact>
                      <MainFlow />
                    </Route>
                    <Route path="/messages" exact>
                      <Messages />
                    </Route>
                    <Route path="/discover" exact>
                      <Discover />
                    </Route>
                    <Route path="/profile" exact>
                      <Profile />
                    </Route>
                  </Switch>
                </div>
            </Router>
    </div>
  );
}

export default App;
